import {
  ELEMENT_ACCORDION,
  ELEMENT_ACCORDION_ITEM,
  ELEMENT_ACCORDION_ITEM_CONTENT,
  ELEMENT_ACCORDION_ITEM_HEADER,
  ELEMENT_H3,
} from '../../pluginKeys';

export const getDefaultAccordionItemValue = () => ({
  type: ELEMENT_ACCORDION_ITEM,
  background: 'gray',
  children: [
    {
      type: ELEMENT_ACCORDION_ITEM_HEADER,
      children: [
        {
          type: ELEMENT_H3,
          children: [
            {
              text: 'Accordion Item Header',
            },
          ],
        },
      ],
    },
    {
      type: ELEMENT_ACCORDION_ITEM_CONTENT,
      children: [{ text: '' }],
    },
  ],
});

export const getDefaultAccordionValue = () => ({
  type: ELEMENT_ACCORDION,
  children: [getDefaultAccordionItemValue(), getDefaultAccordionItemValue()],
});
